import Vue from 'vue';

import { isEmpty } from 'lodash-es';
import { httpClient } from '@api';

import { Remittance } from './remittance.dto';

export default {
  list: async (params) => {
    try {
      let normalizedList = [];

      const res = await httpClient.post('bank-reconciliation/remittance/list', {
        companyId: Vue.prototype.$auth.user()?.selectedCompany?.id,
        ...params,
      });

      if (params?.contentType === 'xlsx' || params?.contentType === 'csv') return res;

      const { data, total, totalSum } = res;

      normalizedList = isEmpty(data) ? [] : data.map((item) => new Remittance(item));

      return { data: normalizedList, total, totalSum };
    } catch (error) {
      console.error(error);
    }
  },
  findOne: async (params) => {
    try {
      const item = await httpClient.post('bank-reconciliation/remittance/find-one', {
        companyId: Vue.prototype.$auth.user()?.selectedCompany?.id,
        ...params,
      });

      return new Remittance(item);
    } catch (error) {
      console.error(error);
    }
  },
  upload: async ({ formData }) => {
    try {
      const response = await httpClient.post('bank-reconciliation/remittance/upload', formData);

      return response;
    } catch (err) {
      console.warn(err);
    }
  },
};
